<template>
  <div class="page-container">
    <AppHeader title="General Settings" />

    <div class="container-fluid">
      <div class="table-container">
        <div class="table-responsive table-wrap">
          <table class="table table-striped table-hover">
            <thead>
              <tr>
                <th>Name</th>
                <th>Edit</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(setting, index) in settings" :key="index">
                <td>{{ setting.name }}</td>
                <td>
                  <button class="btn btn btn-success" @click="navigateTo(setting.route)">
                    View
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from "@/components/AppHeader";

export default {
  name: "GeneralSettings",
  components: { AppHeader },
  data() {
    return {
      settings: [
        { name: "General Settings", route: "settings" },
        { name: "Theme Colors Settings", route: "theme_settings" },
        { name: "Theme Images Settings", route: "theme_images_settings" },
        { name: "Log", route: "logs" }
      ]
    };
  },
  methods: {
    navigateTo(routeName) {
      this.$router.push({ name: routeName });
    }
  }
};
</script>

<style scoped>
.page-container {
  min-height: 100vh;
  background-color: var(--theme-bg-end);
  color: var(--theme-text-main);
}

.content-wrapper {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.table-container {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  overflow: hidden;
}

.table {
  color: white;
  margin-bottom: 0;
}

.table th, .table td {
  border-color: rgba(255, 255, 255, 0.1);
  vertical-align: middle;
}
</style>
